// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3zFI9","errorLogs":"EditorFooter_errorLogs__2tyMp"};